import React from 'react'
import errorFilledOrange from '../../../../assets/images/errorFilledOrange.svg'

const SlrInstructionsSection = ({ t }) => {
	return (
		<div className='new-booking-container'>
			<div className='file-upload-block slr-instructions-block'>
				<div className='article-show-section'>
					<div className='slr-instructions-heading'>
						<img
							src={errorFilledOrange}
							alt='alert-warn'
							title='Warning'
							className='alert-warn'
						/>
						<h3>{t('BOOKING.SLR_INSTRUCTIONS_HEADING')}</h3>
					</div>
					<ul className='article-list'>
						<li className='mb-3'>{t('BOOKING.SLR_INSTRUCTION_1')}</li>
						<li className='mb-3'>{t('BOOKING.SLR_INSTRUCTION_2')}</li>
						<li className='mb-3'>{t('BOOKING.SLR_INSTRUCTION_3')}</li>
						<li className='mb-3'>{t('BOOKING.SLR_INSTRUCTION_4')}</li>
						<li>{t('BOOKING.SLR_INSTRUCTION_5')}</li>
					</ul>
				</div>
			</div>
		</div>
	)
}

export default SlrInstructionsSection
